$(document).ready(function () {
  $(".review-slick").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    vertical: true,
    verticalSwiping: true,
  });

 

  $("#show-drawer").click(function (event) {
    event.preventDefault();
    $(this)
      .parents(".custom-image-text-main-container")
      .find("#drawer")
      .removeClass("hide")
      .addClass("show");
  });

  $(".close").click(function () {
    $("#drawer").removeClass("show").addClass("hide");
  });

  $(window).click(function (event) {
    if ($(event.target).hasClass("drawer1")) {
      $("#drawer").removeClass("show").addClass("hide");
    }
  });

  $(".custom-testimonial-boxes").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    // autoplay: true,
    // autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  });

  $("#show-drawer2").click(function (event) {
    event.preventDefault();
    $(this)
      .parents(".custom-testimonial-img-main-container")
      .find("#drawer2")
      .removeClass("hide")
      .addClass("show");
  });

  $(".close").click(function () {
    $("#drawer2").removeClass("show").addClass("hide");
  });

  $(window).click(function (event) {
    if ($(event.target).hasClass("drawer2")) {
      $("#drawer2").removeClass("show").addClass("hide");
    }
  });

  $("#show-drawer3").click(function (event) {
    event.preventDefault();
    $(this)
      .parents(".custom-tab-text-main-container")
      .find("#drawer3")
      .removeClass("hide")
      .addClass("show");
  });

  $(".close").click(function () {
    $("#drawer3").removeClass("show").addClass("hide");
  });

  $(window).click(function (event) {
    if ($(event.target).hasClass("drawer3")) {
      $("#drawer3").removeClass("show").addClass("hide");
    }
  });

  var rowsToShow = 3;
  var totalRows = $(".custom-table-tr-tbody").length;

  // Initially hide all rows except the first three
  $(".custom-table-tr-tbody").hide();
  $(".custom-table-tr-tbody:lt(" + rowsToShow + ")").show();

  // Check if all rows are already shown; hide the button if true
  if (totalRows <= rowsToShow) {
    $(".custom-table-btn").hide();
  }

  // Functionality for "View All" button
  $(".custom-table-btn").click(function () {
    $(this).hide();
    var visibleRows = $(".custom-table-tr-tbody:visible").length;
    const totalRows = this.closest('.custom-text-table-bottom').querySelectorAll('.custom-table-tr-tbody');
    
    var nextRows = visibleRows + rowsToShow;

    if (nextRows <= totalRows) {
      $(".custom-table-tr-tbody:lt(" + nextRows + ")").show();
    } else {
      $(".custom-table-tr-tbody").show(); // Show all remaining rows
      $(this).hide(); // Hide the button if all rows are shown
    }
  });

  $("#show-drawer4").click(function (event) {
    event.preventDefault();
    $(this)
      .parents(".custom__studiess_sec")
      .find("#drawer4")
      .removeClass("hide")
      .addClass("show");
  });

  $(".close").click(function () {
    $("#drawer4").removeClass("show").addClass("hide");
  });

  $(window).click(function (event) {
    if ($(event.target).hasClass("drawer4")) {
      $("#drawer4").removeClass("show").addClass("hide");
    }
  });

  $(".tab-link").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".tab-link").removeClass("active");
    $(".tab-content").removeClass("active");

    $(this).addClass("active");
    $("#" + tab_id).addClass("active");
  });




// faq accordion
// const items = document.querySelectorAll(".accordionfaq button");
// function toggleAccordion() {
//   const itemToggle = this.getAttribute("aria-expanded");

//   for (i = 0; i < items.length; i++) {
//     items[i].setAttribute("aria-expanded", "false");
//   }
//   if (itemToggle == "false") {
//     this.setAttribute("aria-expanded", "true");
//   }
// }
// items.forEach((item) => item.addEventListener("click", toggleAccordion));

const items = $(".accordion-item button");

  items.click(function () {
    const content = $(this).next(".accordion-content");
    const isExpanded = $(this).attr("aria-expanded") === "true";

    $(".accordion-content").not(content).slideUp();
    items.attr("aria-expanded", "false");

    if (isExpanded) {
      $(this).attr("aria-expanded", "false");
      content.slideUp();
    } else {
      $(this).attr("aria-expanded", "true");
      content.stop(true, true).slideDown();
    }
  });
  
// faq with image accordion

const itemsnew = document.querySelectorAll(".accordion-faq button");
function toggleAccordionNew() {
  const itemToggleNew = this.getAttribute("aria-expanded");

  for (i = 0; i < itemsnew.length; i++) {
    itemsnew[i].setAttribute("aria-expanded", "false");
  }
  if (itemToggleNew == "false") {
    this.setAttribute("aria-expanded", "true");
  }
}
itemsnew.forEach((item) => item.addEventListener("click", toggleAccordionNew));

// faqs new

const itemsnewme = document.querySelectorAll(".accordionfaqs button");
function toggleAccordionNewMe() {
  const itemToggleNewMe = this.getAttribute("aria-expanded");

  for (i = 0; i < itemsnewme.length; i++) {
    itemsnewme[i].setAttribute("aria-expanded", "false");
  }
  if (itemToggleNewMe == "false") {
    this.setAttribute("aria-expanded", "true");
  }
}
itemsnewme.forEach((item) =>
  item.addEventListener("click", toggleAccordionNewMe)
);

// blog slider

$(function () {
  $(".blogslider").each(function () {
    var $this = $(this);
    var $prevButton = $(
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><</button>'
    );
    var $nextButton = $(
      '<button class="slick-next slick-arrow" aria-label="Next" type="button">></button>'
    );

    $this
      .on("init", function (event, slick) {
        $(".slick-counter-new").prepend(
          '<span class="current-new"></span> / <span class="total-new">' +
            slick.slideCount +
            "</span>"
        );
        $(".slick-counter-new .current-new").text(slick.currentSlide + 1);
      })
      .slick({
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        // Add touch support
        touchThreshold: 10,
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $(".slick-counter-new .current-new").text(nextSlide + 1);
      });

    // Append buttons
    $this.prepend($prevButton);
    $this.prepend($nextButton);

    // Add click event handlers to the buttons
    $prevButton.click(function () {
      $this.slick("slickPrev");
    });

    $nextButton.click(function () {
      $this.slick("slickNext");
    });
  });
});


const stickyATC = document.querySelector('.show_sticky_atc_main');
function handleScroll() {
    if (stickyATC) {
        if (window.scrollY > 700 && window.innerWidth > 768) {
          //stickyATC.style.display = 'block';
          stickyATC.classList.add('active');
        }
        else if(window.scrollY > 1200 && window.innerWidth < 767){
          //stickyATC.style.display = 'block';
          stickyATC.classList.add('active');
        }
        else {
          //stickyATC.style.display = 'none';
          stickyATC.classList.remove('active');
        }
    }
}
window.addEventListener('scroll', handleScroll);

$('.sticky_product_button').click(function(){
  $('.custom-featured-product-container form .product-form__submit').click();
});
  
});

document.addEventListener("DOMContentLoaded", function() {
  const italicTags = document.querySelectorAll("i");
  italicTags.forEach((italicTag) => {
    // Replace all instances of "™" with a styled <span> in each <i> tag
    italicTag.innerHTML = italicTag.innerHTML.replace(
      /™/g,
      '<span class="italic-tm">™</span>'
    );
  });

  (function slideshowImages() {
    if (window.innerWidth > 749) return;
    const imagesContainer = document.querySelector('.custom-text-boxes__images');
    const images = imagesContainer.querySelectorAll('img');
    const totalImages = images.length;
    let i = 0;
    setInterval(() => {
      images.forEach(img => img.classList.add('hidden'));
      images[i].classList.remove('hidden');
      i++;
      if (i === totalImages) {
        i = 0;
      }
    }, 1500);
  })();

  (function setFixedTabsHeight() {
    const container = document.querySelector('.custom-tab-text-container');
    if (!container) return;
    
    const tabContents = container.querySelectorAll('.tab-content');
    if(!tabContents?.length) return;

    let maxHeight = tabContents[0].scrollHeight;
    
    tabContents.forEach((tabContent) => {
      maxHeight = Math.max(maxHeight, tabContent.scrollHeight - 20);
    });
  
    // Set the height of all tab contents to the max height
    tabContents.forEach((tabContent) => {
      tabContent.style.height = maxHeight + 'px';
    });
  })();
  
});


$(document).ready(function () {
  $(".accordion_head").click(function () {
      if ($('.accordion_body').is(':visible')) {
          $(".accordion_body").slideUp(300);
          $(".plusminus").html('<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="6.5" y1="0.34375" x2="6.5" y2="13.3438" stroke="#1C3A13"></line><line x1="13" y1="6.84375" x2="-4.37114e-08" y2="6.84375" stroke="#1C3A13"></line></svg>');
      }
      if ($(this).next(".accordion_body").is(':visible')) {
          $(this).next(".accordion_body").slideUp(300);
          $(this).children(".plusminus").html('<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="6.5" y1="0.34375" x2="6.5" y2="13.3438" stroke="#1C3A13"></line><line x1="13" y1="6.84375" x2="-4.37114e-08" y2="6.84375" stroke="#1C3A13"></line></svg>');
      } else {
          $(this).next(".accordion_body").slideDown(300);
          $(this).children(".plusminus").html('<svg width="13" height="14" viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="13" y1="0.843262" x2="-4.37114e-08" y2="0.843261" stroke="#1C3A13"></line></svg>');
      }
  });

  (function teamShowMore() {  
    const container = document.querySelector('.team_sec');
    if (!container) return;
    const teamShowMoreButton = container.querySelector('.show-more-button');
    const hiddenTeamMembers = container.querySelectorAll('.team-member.hidden');

    teamShowMoreButton.addEventListener('click', function(e) {
      hiddenTeamMembers.forEach(member => member.classList.remove('hidden'));
      teamShowMoreButton.closest('.show-more-wrap').classList.add('hidden');
    })
  })();
  
});

